import { apiEndpoint } from "@/configs/api/api-configs";
import { reactive } from "@vue/composition-api";

export default function flashdealEntryMappingModel() {
  const fetchFlashDealEntryMappingList = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/mapping/list`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Inventory_Ref: null,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchFlashDealEntryMappingDraft = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/mapping/Draft`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Inventory_Ref: null,
      Privilege_Alt_Ref_List: null,
    },
  });

  const fetchFlashDealEntryMappingDraftList = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/mapping/drafted_list`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Inventory_Ref: null,
      Page: 1,
      Limit: 10,
      Filters: [],
      Ordering: [],
    },
  });

  const fetchFlashDealEntryMappingUpdate = reactive({
    api: `${apiEndpoint.bcrm_platform}/flashdeal/entry/mapping/Update`,
    method: "POST",
    payload: {
      Campaign_Alt_Ref: null,
      Mapping_Datas: [
        {
          Inventory_Ref: null,
          Privilege_Alt_Ref: null,
          Point: null,
        },
      ],
    },
  });

  return {
    fetchFlashDealEntryMappingList,
    fetchFlashDealEntryMappingDraft,
    fetchFlashDealEntryMappingDraftList,
    fetchFlashDealEntryMappingUpdate
  };
}
